import React from 'react';
import { Outlet } from 'react-router-dom';
import { useMemberAuth } from '../../../contexts/MemberAuthContext';
import { useMemberGyms } from '../hooks/useMemberGyms';
import MTabBar from './MTabBar';
import '../design/member.css';

/* Member app shell — Gympe Light design system (gympe-app-design kit).
   Screens own their headers; the shell provides the paper background and
   the fixed 5-tab bar with the raised Book FAB. */

const MemberLayout: React.FC = () => {
  const { token } = useMemberAuth();
  const { gyms, activeGymId, setActiveGymId, loading } = useMemberGyms(token);

  const activeGym = gyms.find(g => g.id === activeGymId) ?? null;
  const hasClassScheduling = activeGym?.features?.class_scheduling ?? false;

  return (
    <div className="mapp">
      <Outlet context={{ gyms, activeGym, activeGymId, setActiveGymId, loading, hasClassScheduling }} />
      <MTabBar />
    </div>
  );
};

export default MemberLayout;
